export const FETCH_THEME = 'theme/FETCH_THEME'
export const RESET_STORE = 'theme/RESET_STORE'


